"use client";

// Última red: solo entra cuando falla el propio layout raíz, donde `error.tsx`
// ya no existe. Reemplaza el documento entero, así que trae su `<html>` y su
// `<body>` y no puede apoyarse en el CSS de la plataforma (el layout que lo
// carga es justamente el que falló): los estilos van inline a propósito.

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[global-error]", error?.digest ?? "sin digest", error);
  }, [error]);

  return (
    <html lang="es">
      <body style={{ margin: 0, fontFamily: "system-ui, sans-serif" }}>
        <div style={{ padding: 32, maxWidth: 640 }}>
          <h1 style={{ fontSize: 22, margin: "0 0 8px" }}>Algo salió mal</h1>
          <p style={{ fontSize: 14, margin: "0 0 16px" }}>
            La aplicación no se pudo cargar. Reintenta o recarga la página.
          </p>
          {error?.digest ? (
            <p style={{ fontSize: 12, color: "#6b7280", margin: "0 0 16px" }}>
              Identificador del error: {error.digest}
            </p>
          ) : null}
          <button
            type="button"
            onClick={reset}
            style={{
              padding: "10px 16px",
              cursor: "pointer",
              border: "1px solid #101010",
              background: "#101010",
              color: "#fff",
              borderRadius: 6,
            }}
          >
            Reintentar
          </button>
        </div>
      </body>
    </html>
  );
}
